import AuthenticatedRoute from 'eflex/util/authenticated-route';
import QueryParams from 'eflex/constants/bi-query-params';
import { tracked } from '@glimmer/tracking';

export default class BiProcessDataRoute extends AuthenticatedRoute {
  @tracked queryParams = {
    ...QueryParams,
    variableDefIds: {
      refreshModel: true,
    },
  };

  setupController(controller) {
    controller.variableDefIds = controller.variableDefIds.slice(0, 1);
  }
}
